export default __webpack_public_path__ + "static/media/tommyHuynhFinal.e83d8d0f.pdf";